module.exports = __webpack_public_path__ + "img/server.17b1545d.jpg";